import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const More = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <rect x="4.7" y="13.7" width="5.6" height="5.6" rx="2.8" fill="#BEE9FC" stroke="#2B2F38" strokeWidth="1.4" />
      <rect x="13.7" y="13.7" width="5.6" height="5.6" rx="2.8" fill="#BEE9FC" stroke="#2B2F38" strokeWidth="1.4" />
      <rect x="22.7" y="13.7" width="5.6" height="5.6" rx="2.8" fill="#BEE9FC" stroke="#2B2F38" strokeWidth="1.4" />
    </svg>
  )
})

export default More
